<ng-template #terms>
    <div class="w-full flex flex-row items-center justify-end gap-8">
        <p class="text-sm text-hint text-right w-full">versiune: 1.1<br>actualizat: 19 Feb 2026</p>
        <img src="assets/images/logo/logo.svg" class="w-16" alt="Logo Smiles Manager">
    </div>
    <h1 class="text-3xl font-bold mb-6">TERMENI ŞI CONDIŢII DE UTILIZARE</h1>

    <section class="space-y-8">
        <article id="chapter-1">
            <h2 class="text-2xl font-semibold">1. Introducere</h2>

            <p class="mt-2">Vă rugăm să citiți cu atenție termenii și condițiile de utilizare înainte de a folosi soluția Smiles Manager.</p>

            <p class="mt-2">Prezentul acord legal, încheiat între dumneavoastră și S.C. SRP SW Solutions S.R.L., reglementează utilizarea soluției Smiles Manager. Puteți utiliza această soluție exclusiv în conformitate cu acești termeni și condiții.</p>

            <p class="mt-2">Serviciile disponibile prin intermediul platformei Smiles Manager pot evolua în timp, prin introducerea de noi funcționalități sau îmbunătățiri. Deși ne dorim o experiență stabilă și continuă, anumite servicii pot fi modificate, suspendate sau întrerupte fără notificare prealabilă, dacă situația o impune. În cazul apariției unor dificultăți tehnice care pot afecta funcționarea optimă a platformei, vom interveni prompt pentru remediere, inclusiv prin măsuri precum limitarea temporară a accesului sau a unor funcționalități, cu scopul de a restabili buna funcționare cât mai rapid.</p>

            <p class="mt-2">Conform Legii comerțului electronic (Legea nr. 365/2002, cu modificările aduse prin Legea nr. 121/2006):</p>

            <blockquote class="border-l-4 pl-4 italic my-2">
                Art. 7 - Validitatea, efectele juridice și proba contractelor încheiate prin mijloace electronice<br>
                (1) Contractele încheiate prin mijloace electronice produc toate efectele pe care legea le recunoaște contractelor, atunci când sunt întrunite condițiile cerute de lege pentru validitatea acestora.<br>
                (2) Pentru validitatea contractelor încheiate prin mijloace electronice nu este necesar consimțământul prealabil al părților asupra utilizării mijloacelor electronice.
            </blockquote>

            <p class="mt-2">Prin accesarea site-ului și utilizarea soluției Smiles Manager, <b>vă exprimați acordul cu privire la acești termeni și condiții de utilizare. Dacă nu sunteți de acord cu aceștia, nu puteți utiliza soluția Smiles Manager, site-urile <a href="https://smilesmanager.com" class="text-blue-600 underline">smilesmanager.com</a>, <a href="https://smilesmanager.ro" class="text-blue-600 underline">smilesmanager.ro</a>, și aplicațiile aferente iOS/Android.</b></p>

            <p class="mt-2">Acest acord („Acordul”) reprezintă o convenție cu caracter obligatoriu, încheiată între o persoană juridică de drept public sau privat (sau un reprezentant al acesteia, în continuare „Utilizator” sau „dumneavoastră”) și S.C. SRP SW Solutions S.R.L. („Furnizorul”), privind condițiile de accesare și utilizare a soluției Smiles Manager.</p>

            <p class="mt-2">Soluția Smiles Manager este destinată exclusiv persoanelor cu vârsta de cel puțin 18 ani. Prin utilizarea platformei, declarați că aveți minimum 18 ani și că toate datele și informațiile furnizate sunt reale și corecte.</p>

            <p class="mt-2">Soluția Smiles Manager nu este destinată utilizatorilor în sensul art. 1, punctele 6 și 7 din Legea nr. 365/2002, respectiv persoanelor fizice care acționează în nume propriu, fără a reprezenta legal o entitate juridică de drept public sau privat.</p>

            <p class="mt-2">În cazul în care soluția Smiles Manager este achiziționată sau utilizată de o persoană fizică în nume propriu, aceasta își asumă în mod expres și fără rezerve excluderea aplicabilității legislației privind protecția consumatorilor, inclusiv dispozițiile O.G. nr. 21/1992 și ale altor acte normative conexe.</p>

            <p class="mt-2">Astfel, persoanele fizice care utilizează platforma în nume propriu renunță expres la dreptul de a solicita restituirea sumelor achitate, conform dispozițiilor legislației privind protecția consumatorilor. Furnizorul este îndreptățit să refuze orice cerere financiară, compensatorie sau de altă natură venită din partea unei astfel de persoane.</p>
        </article>

        <article id="chapter-1-1">
            <h2 class="text-2xl font-semibold">1.1 Definiții</h2>
            <p class="mt-2">În scopul prezentului Acord, cu excepția cazurilor în care se prevede altfel prin definiție sau se oferă o altă interpretare în Acord ori rezultă altfel din context, următoarele cuvinte și sintagme vor avea semnificația indicată mai jos:</p>

            <p class="mt-2"><b>Furnizorul</b><br> se referă la entitatea juridică care oferă serviciile Smiles Manager, si anume S.C. SRP SW Solutions S.R.L.</p>

            <p class="mt-2"><b>Administratorii platformei</b><br> se referă la acele persoane fizice sau juridice, angajate, sau autorizate de către S.C. SRP SW Solutions S.R.L. pentru a asigura mentenanța, dezvoltarea si buna funcționare a platformei Smiles Manager.</p>

            <p class="mt-2"><b>Serviciile sau platforma Smiles Manager</b><br> se referă la totalitatea serviciilor oferite de S.C. SRP SW Solutions S.R.L prin intermediul, și in jurul platformei Smiles Manager pe care o deține dar și prin intermediul serviciilor partenerilor Smiles Manager. Ca de exemplu (lista nu este exhaustiva):</p>
            <ul class="list-disc list-inside ml-4 mt-2 space-y-0">
                <li>Acces la sistemul informatic Smiles Manager.</li>
                <li>Găzduire informații clinica și pacienți atât in format text cat și multimedia sau binar.</li>
                <li>Integrarea cu periferice.</li>
                <li>Integrarea cu sisteme de plata si comunicare automata.</li>
                <li>Training-uri si prezentări.</li>
                <li>Intermediere vânzare echipamente si consumabile.</li>
                <li>...</li>
            </ul>

            <p class="mt-2"><b>Utilizator</b><br> se referă la persoana fizica sau juridica care utilizează platforma Smiles Manager, atât in perioada DEMO, cat și după achiziția unui abonament. Este persoana fizica sau juridica care furnizează date de înregistrare in platforma, și care au fost folosite de către administratorii platformei pentru a înregistra un cont de clinica.</p>

            <p class="mt-2"><b>Cont de Utilizator</b><br> se referă la contul de înregistrare al unei persoane fizice, in cadrul unei clinici. Acest cont poate fi creat atât de către administratorii platformei, cat și de către proprietarul sau administratorii unei clinici înregistrate in platforma Smiles Manager.</p>

            <p class="mt-2"><b>Date cu caracter personal</b><br> înseamnă informațiile referitoare la un Utilizator persoană fizică, precum: prenume, nume, CNP, seria și numărul cărții de identitate, număr de telefon, adresă poștală, email.</p>

            <p class="mt-2"><b>Informații pentru înregistrare</b><br> înseamnă unele date cu caracter personal, în cazul persoanelor fizice, și datele de identificare ale persoanelor juridice, precum: denumirea, sediul social, numărul de înregistrare la Oficiul Registrului Comerțului sau decizia înființării la tribunal, precum și alte registre naționale/locale de evidență a persoanelor juridice, după caz, Codul Unic de Înregistrare, inclusiv informațiile necesare pentru emiterea facturii (e.g., banca și numărul de cont bancar, adresa sediului social, nr. de telefon).</p>
        </article>

        <article id="chapter-2">
            <h2 class="text-2xl font-semibold">2. Modificări aduse acordului</h2>

            <p class="mt-2">Furnizorul își rezervă dreptul de a aduce amendamente și de a modifica oricând acești termeni și condiții de utilizare.</p>

            <p class="mt-2">Versiunea în vigoare va fi cea publicată pe site-ul <a href="https://www.smilesmanager.com" class="text-blue-600 underline">www.smilesmanager.com</a>.</p>

            <p class="mt-2">Modificările intră în vigoare imediat după publicarea acestora pe website și veți fi notificat(ă) în cadrul soluției Smiles Manager sau prin e-mail.</p>
        </article>

        <article id="chapter-3">
            <h2 class="text-2xl font-semibold">3. Crearea contului și plata abonamentului și a serviciilor suplimentare</h2>

            <p class="mt-2">Orice utilizator care deține o clinică poate solicita crearea unui cont de administrator pentru clinica sa, accesând pagina <a href="https://smilesmanager.com/sign-up" class="text-blue-600 underline">https://smilesmanager.com/sign-up</a>.</p>

            <p class="mt-2">După completarea formularului, un reprezentant Smiles Manager vă va contacta și va începe, împreună cu dumneavoastră, procesul de înrolare în aplicație.</p>

            <p class="mt-2">Abonamentele Smiles Manager sunt personalizate pentru fiecare clinică și includ:</p>

            <ul class="list-disc list-inside ml-4 mt-2">
                <li>Abonament fix lunar / număr de medici</li>
                <li>Taxă per resurse consumate (SMS, email, spațiu de stocare, AI)</li>
            </ul>

            <p class="mt-2">Prețul este comunicat administratorului de clinică prin e-mail.</p>

            <p class="mt-2">La momentul efectuării plății, suma achitată trebuie să reflecte totalul facturii, format din costul lunar recurent și valoarea aferentă resurselor consumate. Resursele consumate sunt vizibile în aplicația Smiles Manager.</p>

            <p class="mt-2">Prețurile pot fi modificate oricând, fără obligația anunțării prealabile.</p>

            <p class="mt-2">Platforma Smiles Manager oferă perioada de încercare de minim o săptămâna din acest motiv, o data activat un abonament si/sau achiziționate resurse, ne rezervam dreptul de a <b>NU</b> onora orice cerere de anulare si rambursare contravaloare abonament si/sau resurse neconsumate.</p>

            <h3 class="text-xl font-medium mt-4">Plata prin ordin de plată (OP)</h3>

            <p class="mt-2">Plata se va efectua în unul dintre conturile bancare indicate pe factura proformă emisă. În detaliile plății trebuie menționate informații relevante pentru identificarea plății, precum: factura achitată și/sau Codul Unic de Înregistrare (CUI) al firmei pentru care se achiziționează abonamentul sau serviciile Smiles Manager.</p>

            <p class="mt-2">Este responsabilitatea dumneavoastră să vă informați cu privire la comisioanele aplicate de către bancă pentru tranzacțiile efectuate prin OP. Prin achitarea abonamentului sau a serviciilor prin OP, acceptați implicit plata acestor comisioane.</p>

            <p class="mt-2">În cazul în care nu vă informați sau nu achitați comisioanele bancare, Furnizorul își rezervă dreptul de a acționa astfel:</p>

            <ul class="list-disc list-inside ml-4 mt-2">
                <li>Fie ajustează perioada de valabilitate a abonamentului, conform sumei efectiv primite;</li>
                <li>Fie suspendă abonamentul, urmând să returneze în contul dumneavoastră exact suma încasată de Furnizor în urma plății efectuate.</li>
            </ul>
        </article>

        <article id="chapter-4">
            <h2 class="text-2xl font-semibold">4. Declarații ale utilizatorului</h2>

            <p class="mt-2">Prin utilizarea soluției Smiles Manager, declarați și garantați următoarele:</p>

            <ul class="list-disc list-inside ml-4 mt-2 space-y-2">
                <li>Toate informațiile furnizate pentru înregistrare sunt corecte, precise și nu induc în eroare.</li>
                <li>Datele și informațiile furnizate sunt reale la momentul completării cererii.</li>
                <li>Sunteți reprezentantul legal al firmei pe care o înscrieți în soluția Smiles Manager sau dețineți o împuternicire din partea reprezentantului legal pentru a înscrie respectiva entitate.</li>
            </ul>

            <p class="mt-2">Furnizorul are dreptul de a bloca accesul dumneavoastră în aplicația Smiles Manager și vă poate solicita dovezi care să ateste faptul că aveți calitatea de reprezentant legal sau împuternicirea necesară. În lipsa acestor dovezi, nu veți beneficia de protecția oferită de legislația privind drepturile consumatorilor (O.G. nr. 21/1992 și actele normative conexe).</p>

            <p class="mt-2">Prin urmare, vă asumați că, în calitate de persoană fizică ce acționează în nume propriu, nu veți pretinde garanții sau rambursări din partea Furnizorului. Aceasta include, dar nu se limitează la, solicitări de restituire a sumei plătite pentru utilizarea soluției Smiles Manager.</p>

            <p class="mt-2">De asemenea, declarați că aveți cel puțin 18 ani împliniți.</p>
        </article>

        <article id="chapter-5">
            <h2 class="text-2xl font-semibold">5. Activități interzise</h2>

            <p class="mt-2">
                Nu puteți accesa sau utiliza soluția Smiles Manager în alte scopuri decât cele puse la dispoziție de către Furnizor și comunicate public pe site-ul
                <a href="https://www.smilesmanager.com" class="text-blue-600 underline">www.smilesmanager.com</a>.
            </p>

            <p class="mt-2">Activitățile interzise includ, fără a se limita la:</p>

            <ul class="list-disc list-inside ml-4 mt-2 space-y-2">
                <li>Activitate criminală sau generatoare de prejudicii, inclusiv pornografia infantilă, fraudă, trafic de materiale obscene, trafic de droguri, jocuri de noroc, hărțuire, urmărire, trimiterea de mesaje electronice nedorite, încălcarea drepturilor de autor, ale brevetelor sau furtul de secrete comerciale.</li>
                <li>Extragerea sistematică de date sau alt conținut din soluția Smiles Manager pentru a crea, direct sau indirect, o colecție, compilație, bază de date sau un director, fără acordul scris al Furnizorului.</li>
                <li>Utilizarea neautorizată a serviciilor Furnizorului, inclusiv colectarea numelor de utilizator și/sau adreselor de e-mail în scopul transmiterii de mesaje nesolicitate.</li>
                <li>Încadrarea neautorizată (framing) sau conectarea neautorizată la soluția Smiles Manager.</li>
                <li>Utilizarea automată a sistemului (ex: scripturi pentru trimitere de mesaje, algoritmi de tip data-mining, roboți sau alte unelte de extragere de date).</li>
                <li>Interferarea, întreruperea sau generarea unei sarcini excesive asupra soluției Smiles Manager sau a rețelelor și serviciilor aferente.</li>
                <li>Încercarea de a vă asuma identitatea unui alt Utilizator ori a unei alte persoane.</li>
                <li>Utilizarea contului altui Utilizator fără permisiune. Permisiunea trebuie sa existe in scris si ea trebuie sa fie semnata de Utilizatorul care a încredințat contul terței persoane. Administratorii platformei isi rezerva dreptul de a cere acest acord scris. In caz contrar administratorii platformei Smiles Manager pot recurge la restricționarea accesului pentru contul utilizat abuziv.</li>
                <li>Utilizarea informațiilor obținute prin intermediul platformei în scopul de a hărțui, abuza sau prejudicia alte persoane.</li>
                <li>Utilizarea serviciilor Furnizorului pentru a concura cu Furnizorul sau pentru a presta servicii similare în calitate de agent ori reprezentant.</li>
                <li>Descifrarea, decompiler, dezasamblarea sau realizarea de reverse engineering asupra oricărei componente software a soluției Smiles Manager.</li>
                <li>Utilizarea platformei într-un mod incompatibil cu legile și reglementările în vigoare.</li>
                <li>Crearea unui cont sau utilizarea platformei în numele unei entități juridice fără a fi administrator legal sau fără acordul firmei respective.</li>
            </ul>

            <p class="mt-4">
                În eventualitatea în care Utilizatorul săvârșește una sau mai multe dintre acțiunile menționate mai sus, Furnizorul poate, în funcție de natura acțiunii:
            </p>

            <ul class="list-disc list-inside ml-4 mt-2 space-y-2">
                <li>Să sesizeze organele competente și să furnizeze automat toate datele dumneavoastră.</li>
                <li>Să suspende contul de utilizator până la finalizarea investigațiilor sau până la o decizie unilaterală de reactivare din partea Furnizorului.</li>
                <li>Să aplice ambele măsuri menționate anterior, precum și alte demersuri necesare pentru restabilirea situației anterioare.</li>
            </ul>

            <p class="mt-2">
                În toate situațiile menționate, dacă acțiunile Utilizatorului au generat prejudicii, costuri sau pierderi de profit pentru Furnizor, Utilizatorul este responsabil pentru acoperirea integrală a acestor daune, precum și a tuturor cheltuielilor judiciare aferente demersurilor de recuperare.
            </p>
        </article>

        <article id="chapter-6">
            <h2 class="text-2xl font-semibold">6. Drepturile de proprietate intelectuală</h2>

            <p class="mt-2">
                Toate drepturile de proprietate intelectuală asupra soluției informatice Smiles Manager, inclusiv designul, structura, codul sursă, logo-ul, imaginile și conținutul furnizat, aparțin S.C. SRP SW Solutions S.R.L. și sunt protejate conform legislației române și europene în vigoare.
            </p>

            <p class="mt-2">
                Mărcile, denumirile comerciale și siglele S.C. SRP SW Solutions S.R.L. nu pot fi utilizate, copiate, imitate sau asociate cu alte produse ori servicii fără acordul scris prealabil al deținătorului.
            </p>

            <p class="mt-2">
                Conținutul soluției este oferit „CA ATARE” și nu poate fi reprodus, distribuit, transmis, vândut, licențiat sau exploatat în niciun scop fără permisiunea expresă, scrisă, a S.C. SRP SW Solutions S.R.L. Este interzisă recuperarea sistematică de date sau conținut pentru crearea unor colecții, baze de date sau produse derivate.
            </p>

            <p class="mt-2">
                Utilizatorului nu i se transferă niciun drept de proprietate asupra soluției Smiles Manager. Sunt interzise redistribuirea, decompilarea, utilizarea tehnicilor de reverse engineering, dezasamblarea sau orice altă metodă de transformare a soluției într-o formă accesibilă omului.
            </p>

            <p class="mt-2">
                Nimic din prezentul document nu constituie o licență sau un drept implicit asupra vreunui brevet, mărci comerciale sau alt drept de proprietate intelectuală aparținând S.C. SRP SW Solutions S.R.L.
            </p>
        </article>

        <article id="chapter-7">
            <h2 class="text-2xl font-semibold">7. Limitarea răspunderii</h2>

            <p class="mt-2">
                Utilizarea soluției Smiles Manager se face pe propria răspundere a Utilizatorului. S.C. SRP SW Solutions S.R.L. nu este responsabilă pentru daune directe sau indirecte care pot rezulta din accesarea ori utilizarea soluției sau a informațiilor furnizate prin intermediul acesteia.
            </p>

            <p class="mt-2">
                De asemenea, SRP SW Solutions S.R.L. nu răspunde pentru eventuale erori sau omisiuni din conținutul soluției.
            </p>

            <p class="mt-2">
                Este strict interzisă efectuarea de operațiuni neautorizate asupra soluției Smiles Manager, precum și orice tentativă de natură abuzivă sau frauduloasă, inclusiv, dar fără a se limita la:
            </p>

            <ul class="list-disc list-inside ml-4 mt-2 space-y-2">
                <li>accesul neautorizat;</li>
                <li>modificarea sau copierea conținutului în scopuri comerciale;</li>
                <li>blocarea accesului altor utilizatori;</li>
                <li>orice altă intervenție ilegală asupra platformei.</li>
            </ul>

            <p class="mt-2">
                Astfel de acțiuni vor fi sancționate conform legislației aplicabile în vigoare.
            </p>

            <p class="mt-2">
                În niciun caz S.C. SRP SW Solutions S.R.L., angajații, reprezentanții, directorii sau agenții săi nu vor fi răspunzători față de Utilizator sau față de terți pentru daune indirecte, speciale, viitoare, punitive sau incidentale (inclusiv pierderi de profit), rezultate din utilizarea soluției Smiles Manager, chiar și în situația în care au fost informați în prealabil despre posibilitatea unor astfel de prejudicii.
            </p>
        </article>

        <article id="chapter-7-1">
            <h3 class="text-2xl font-semibold">7.1 Limitarea răspunderii privind conformitatea administrativă și medicală</h3>

            <p class="mt-2">
                <b>Natura Serviciului</b><br> Furnizorul oferă o soluție tehnică (SaaS) destinată digitalizării fluxurilor de lucru. Platforma este un instrument de stocare și procesare a datelor, nu un serviciu de consultanță medicală sau juridică.
            </p>

            <p class="mt-2">
                <b>Responsabilitatea trasabilității sterilizării</b><br> Utilizatorul (Unitatea Medicală) poartă întreaga răspundere pentru respectarea normelor de igienă și sterilizare. Furnizorul nu poate fi tras la răspundere dacă datele introduse în sistem sunt eronate, incomplete sau dacă procesul fizic de sterilizare nu a fost efectuat conform normelor DSP.
            </p>

            <p class="mt-2">
                <b>Controale ale Autorităților</b><br> În cazul unor controale efectuate de instituții abilitate (ex: DSP, Colegiul Medicilor), Utilizatorul este singurul responsabil pentru prezentarea documentației și justificarea procedurilor interne. Furnizorul nu garantează că utilizarea software-ului asigură automat conformitatea cu toate reglementările locale, aceasta depinzând de utilizarea corectă și completă a aplicației de către personalul medical.
            </p>
            <p class="mt-2">
                <b>Documente Semnate Digital</b><br> Furnizorul pune la dispoziție tehnologia de semnare, însă revine în sarcina Utilizatorului să se asigure că tipul de semnătură utilizat este acceptat pentru tipul specific de document (ex: Consimțământul Informat) conform legislației privind semnătura electronică.
            </p>
        </article>

        <article id="chapter-8">
            <h2 class="text-2xl font-semibold">8. Prelucrarea datelor cu caracter personal conform GDPR</h2>

            <p class="mt-2">
                Prin utilizarea soluției Smiles Manager, vă exprimați acordul și împuterniciți S.C. SRP SW Solutions S.R.L. să prelucreze datele cu caracter personal pe care le furnizați, exclusiv în scopul prestării serviciilor aferente pachetului Smiles Manager selectat.
            </p>

            <h3 class="text-xl font-medium mt-4">Date colectate</h3>
            <ul class="list-disc list-inside ml-4 mt-2 space-y-2">
                <li><strong>La crearea contului:</strong> adresa de e-mail, număr de telefon, nume și prenume. Administratorul de clinică trebuie să furnizeze și datele de identificare ale firmei.</li>
                <li><strong>În utilizarea platformei:</strong> date necesare activității medicale, inclusiv nume și prenume pacient, CNP, data nașterii, adresa, date de contact, informații despre asigurare, status dentar, diagnostice, tratamente, alergii, radiografii, imagini etc.</li>
            </ul>

            <p class="mt-2">
                S.C. SRP SW Solutions S.R.L. acționează în calitate de <strong>Împuternicit</strong>, prelucrând aceste date în numele și pe baza instrucțiunilor Utilizatorului (medic/clinică), în conformitate cu <strong>Regulamentul (UE) 2016/679 (GDPR)</strong>. Utilizatorul este responsabil pentru obținerea consimțământului pacienților, acolo unde este necesar.
            </p>

            <h3 class="text-xl font-medium mt-4">Roluri privind protecția datelor</h3>
            <p class="mt-2"><strong>Utilizatorul – Operator de date:</strong> Medicul, clinica sau cabinetul stomatologic este responsabil de legalitatea colectării, introducerii și gestionării datelor.</p>
            <p class="mt-2">Obligațiile Utilizatorului includ, fără a se limita la:</p>
            <ul class="list-disc list-inside ml-4 mt-2 space-y-2">
                <li>Informarea pacienților cu privire la prelucrarea datelor;</li>
                <li>Obținerea consimțământului, unde este cazul;</li>
                <li>Respectarea principiilor GDPR (legalitate, transparență, minimizare etc.);</li>
                <li>Gestionarea cererilor de acces, rectificare sau ștergere a datelor;</li>
                <li>Păstrarea evidenței activităților de prelucrare, unde este aplicabil.</li>
            </ul>

            <p class="mt-4"><strong>SRP SW Solutions S.R.L. – Împuternicit:</strong></p>
            <p class="mt-2">Obligațiile Furnizorului includ:</p>
            <ul class="list-disc list-inside ml-4 mt-2 space-y-2">
                <li>Implementarea măsurilor tehnice și organizatorice adecvate pentru protejarea datelor;</li>
                <li>Prelucrarea exclusiv în scopurile stabilite de Operator;</li>
                <li>Asistență în îndeplinirea obligațiilor legale ale Operatorului;</li>
                <li>Notificarea Utilizatorului în caz de incidente de securitate;</li>
                <li>Neimplicarea altor împuterniciți fără acordul prealabil al Utilizatorului.</li>
            </ul>

            <h3 class="text-xl font-medium mt-4">Comunicări către pacienți</h3>
            <p class="mt-2">Prin intermediul platformei, pot fi trimise notificări prin e-mail sau SMS în scopuri precum:</p>
            <ul class="list-disc list-inside ml-4 mt-2 space-y-2">
                <li>Reamintiri, confirmări sau reprogramări pentru consultații;</li>
                <li>Comunicări comerciale/marketing, dacă pacientul și-a exprimat consimțământul.</li>
            </ul>

            <p class="mt-2">Trimiterea SMS-urilor presupune completarea numărului de telefon și utilizarea serviciilor integrate. Aceste mesaje sunt trimise doar la inițiativa Utilizatorului.</p>
            <p class="mt-2">Utilizatorul este responsabil de obținerea consimțământului pacienților pentru comunicările comerciale, acolo unde este necesar.</p>

            <h3 class="text-xl font-medium mt-4">Infrastructura de stocare și securitate</h3>
            <p class="mt-2">
                Toate datele sunt stocate în cloud pe serverele <strong>Amazon Web Services (AWS)</strong>, localizate în Uniunea Europeană. AWS respectă standardele GDPR și este certificat conform EU-U.S. Privacy Framework.
            </p>
            <p class="mt-2">
                Datele beneficiază de backup automat periodic, în condiții de maximă siguranță. Autentificarea este gestionată de AWS, iar parolele nu sunt stocate în platformă.
            </p>

            <h3 class="text-xl font-medium mt-4">Drepturile Utilizatorului privind datele personale</h3>
            <ul class="list-disc list-inside ml-4 mt-2 space-y-2">
                <li><strong>Dreptul de acces</strong> – solicitarea de informații despre activitățile de prelucrare.</li>
                <li><strong>Dreptul la rectificare</strong> – corectarea sau completarea datelor inexacte.</li>
                <li><strong>Dreptul la ștergere</strong> („dreptul de a fi uitat”).</li>
                <li><strong>Dreptul la restricționare</strong> – în anumite cazuri prevăzute de lege.</li>
                <li><strong>Dreptul la opoziție</strong> – în special pentru prelucrările bazate pe interes legitim.</li>
                <li><strong>Dreptul la portabilitate</strong> – primirea datelor într-un format structurat și transferul către alt operator.</li>
                <li><strong>Dreptul de a depune plângere</strong> – la ANSPDCP privind modul de prelucrare.</li>
                <li><strong>Dreptul de retragere a consimțământului</strong> – cu efect pentru viitor, fără a afecta prelucrarea anterioară.</li>
            </ul>
        </article>

        <article id="chapter-9">
            <h2 class="text-2xl font-semibold">9. Legea aplicabilă</h2>

            <p class="mt-2">
                Toate aspectele juridice, drepturile și măsurile reparatorii referitoare la orice act, eveniment sau incident întreprinse în legătură cu soluția Smiles Manager sau serviciile oferite de Furnizor vor fi guvernate și interpretate în conformitate cu legislația în vigoare din România.
            </p>

            <p class="mt-2">
                Sunt exceptate de la aplicare dispozițiile <strong>Ordonanței Guvernului nr. 21/1992</strong> și ale actelor normative conexe, care se aplică exclusiv destinatarilor persoane fizice. Furnizorul își declină în mod expres răspunderea în ceea ce privește aplicabilitatea acestor reglementări, în condițiile menționate în prezentul document.
            </p>
        </article>

        <article id="chapter-10">
            <h2 class="text-2xl font-semibold">10. Soluționarea litigiilor</h2>

            <p class="mt-2">
                În cazul unui litigiu între Utilizatori și orice alt terț, înțelegeți și acceptați că Furnizorul nu are nicio obligație de a interveni. Prin prezentul Acord, exonerați Furnizorul, precum și funcționarii, angajații, agenții și succesorii săi legali, de orice plângeri, cereri și prejudicii de orice natură — cunoscute sau necunoscute, previzibile sau imprevizibile, dezvăluite sau confidențiale — care decurg din sau sunt legate în orice mod de astfel de litigii și/sau de utilizarea serviciilor Furnizorului.
            </p>

            <p class="mt-2">
                Toate plângerile, litigiile sau neînțelegerile dintre Utilizator (entitate juridică de drept public sau privat, sau reprezentant al acesteia) și Furnizor, care decurg din interpretarea, funcționalitatea ori utilizarea soluției Smiles Manager sau a serviciilor asociate, și care nu pot fi soluționate pe cale amiabilă prin discuții directe în termen de <strong>30 (treizeci) de zile lucrătoare</strong> de la înregistrarea reclamației, vor fi soluționate exclusiv de instanțele judecătorești competente din România.
            </p>
        </article>

    </section>
</ng-template>


<ng-template #confidentiality>
    <div class="w-full flex flex-row items-center justify-end gap-8">
        <p class="text-sm text-hint text-right w-full">versiune: 1<br>actualizat: 10 Ian 2025</p>
        <img src="assets/images/logo/logo.svg" class="w-16" alt="Logo Smiles Manager">
    </div>

    <h1 class="text-3xl font-bold mb-6">Politica de confidențialitate</h1>

    <!-- Descriere introductivă -->
    <div class="mb-8 space-y-4 text-base">
        <p>
            Această politică de confidențialitate se aplică serviciilor oferite prin intermediul aplicației Smiles Manager, dezvoltată și deținută de S.C. SRP SW Solutions S.R.L.
        </p>
        <p>
            Scopul acestei politici este să vă informăm în legătură cu tipul de date pe care le colectăm, de ce le colectăm și cum le folosim atunci când utilizați aplicația noastră. De asemenea, vă explicăm măsurile pe care le luăm pentru a vă proteja informațiile personale.
        </p>
        <p>
            Protejarea confidențialității dumneavoastră este importantă pentru noi. Ne angajăm să tratăm datele cu responsabilitate, transparență și grijă, asigurându-ne că acestea sunt păstrate în siguranță pe tot parcursul utilizării serviciilor oferite prin Smiles Manager.
        </p>
    </div>

    <article id="chapter-conf-1">
        <h2 class="text-2xl font-semibold">1. Valorile noastre în prelucrarea datelor cu caracter personal</h2>

        <p class="mt-2">
            Când vine vorba de datele tale personale, acționăm cu respect și responsabilitate. Iată principiile care ne ghidează în procesul de colectare și utilizare a acestor informații:
        </p>

        <ul class="list-disc list-inside ml-4 mt-2 space-y-2">
            <li><strong>Respectarea legii și echitate</strong> – Prelucrăm datele în mod legal, corect și transparent față de tine.</li>
            <li><strong>Responsabilitate</strong> – Ne asumăm răspunderea pentru modul în care gestionăm datele personale.</li>
            <li><strong>Scop clar și bine definit</strong> – Colectăm și folosim datele doar în scopuri legitime, pe care le comunicăm clar.</li>
            <li><strong>Date relevante, nu mai mult decât e necesar</strong> – Solicităm doar informațiile strict necesare pentru scopurile declarate.</li>
            <li><strong>Transparență și informare</strong> – Ne asigurăm că știi ce date colectăm, de ce și cum le folosim.</li>
            <li><strong>Securitate și protecție</strong> – Aplicăm măsuri tehnice și organizatorice pentru a proteja datele împotriva accesului neautorizat sau pierderii.</li>
        </ul>
    </article>
    <br>

    <article id="chapter-conf-2">
        <h2 class="text-2xl font-semibold">2. Ce include politica noastră de confidențialitate</h2>

        <p class="mt-2">
            Această politică de confidențialitate explică modul în care colectăm, stocăm și folosim datele tale atunci când utilizezi serviciile oferite prin aplicația Smiles Manager.
        </p>

        <p class="mt-2">
            Politica acoperă și situațiile în care, cu acordul tău explicit, datele tale sau ale clienților tăi pot fi transmise către servicii externe integrate, cum ar fi un program de analiză a radiografiilor, un serviciu de trimitere SMS-uri sau un procesator de plăți online, atunci când alegi să conectezi aceste servicii la contul tău Smiles Manager.
        </p>

        <p class="mt-2">
            Este important de știut că această politică se aplică exclusiv serviciilor oferite prin Smiles Manager. Nu acoperă practicile altor terțe părți pe care nu le deținem sau controlăm — cum ar fi furnizori de software pentru analiză sau trimitere de SMS-uri ori servicii de plăți externe („Servicii terță parte”).
        </p>

        <p class="mt-2">
            Îți recomandăm să consulți întotdeauna politicile de confidențialitate ale acestor servicii externe pentru a înțelege cum îți gestionează și protejează datele.
        </p>
    </article>
    <br>

    <article id="chapter-conf-3">
        <h2 class="text-2xl font-semibold">3. Ce date colectăm și în ce scop</h2>

        <p class="mt-2">
            Pentru a crea un cont în Smiles Manager, este necesar să furnizați anumite informații de bază, precum numele de utilizator, o parolă (gestionată securizat prin AWS) și datele de identificare ale cabinetului sau clinicii stomatologice pentru care se creează contul.
        </p>

        <p class="mt-2">
            Datele personale pe care le introduceți în platformă – fie că sunt ale dumneavoastră, ale pacienților sau ale angajaților – vă aparțin în totalitate. Smiles Manager le utilizează exclusiv pentru a vă furniza serviciile aferente platformei, conform scopului pentru care v-ați creat contul. Aceste date nu sunt folosite în scopuri comerciale, analitice sau de marketing de către S.C. SRP SW Solutions S.R.L., în afara celor inițiate și controlate de utilizator.
        </p>

        <p class="mt-2">
            Respectăm în totalitate legislația privind protecția datelor cu caracter personal, inclusiv Regulamentul (UE) 2016/679 (GDPR), și aplicăm măsuri tehnice și organizatorice adecvate pentru a asigura confidențialitatea, integritatea și securitatea tuturor operațiunilor care implică date personale.
        </p>

        <h3 class="text-xl font-medium mt-4">Date despre utilizator</h3>
        <p class="mt-2">
            Pentru a crea un cont în platforma Smiles Manager și a beneficia de serviciile oferite, este necesar să furnizați:
        </p>
        <ul class="list-disc list-inside ml-4 mt-2 space-y-2">
            <li>Adresa de email (care devine numele de utilizator);</li>
            <li>O parolă securizată (gestionată prin AWS);</li>
            <li>Datele cabinetului sau clinicii stomatologice.</li>
        </ul>

        <p class="mt-2">
            Recomandăm utilizarea unei adrese de email de firmă, aceasta fiind folosită pentru toate comunicările esențiale cu echipa Smiles Manager. Opțional, utilizatorul își poate adăuga și numele personal în setările contului, care poate apărea pe chitanțe, în activități sau alte documente generate.
        </p>

        <p class="mt-2">
            Prelucrarea acestor informații este esențială pentru furnizarea serviciilor contractate și generarea documentelor personalizate conform cerințelor utilizatorului.
        </p>

        <p class="mt-2">
            Utilizatorul poate introduce în mod liber și alte date personale în facturi, fișe de tratament sau documente medicale – date care nu pot fi predefinite de către Furnizor.
        </p>

        <p class="mt-2">
            Toate datele personale introduse în contul dumneavoastră rămân proprietatea dumneavoastră. Smiles Manager nu utilizează aceste informații în alt scop decât furnizarea serviciilor contractate, conform secțiunii „Prelucrarea datelor cu caracter personal conform GDPR” din Termeni și Condiții.
        </p>

        <h3 class="text-xl font-medium mt-4">Datele pacienților și responsabilitatea operatorului</h3>
        <p class="mt-2">
            Utilizatorii (medici, clinici, cabinete stomatologice) pot documenta și gestiona date personale ale pacienților, inclusiv:
        </p>
        <ul class="list-disc list-inside ml-4 mt-2 space-y-2">
            <li>Date de contact: nume, prenume, adresă de email, număr de telefon;</li>
            <li>Date medicale sensibile: status dentar, diagnostice, tratamente, intervenții, alergii, scheme de tratament;</li>
            <li>Informații privind consimțământul: acorduri semnate sau refuzuri înregistrate conform legii.</li>
        </ul>

        <p class="mt-2">
            Aceste funcționalități sunt esențiale pentru desfășurarea activității medicale. Platforma oferă cadrul tehnic necesar stocării și gestionării acestor date în condiții de siguranță.
        </p>

        <p class="mt-2">
            S.C. SRP SW Solutions S.R.L. acționează în calitate de <strong>împuternicit</strong>, iar medicul sau clinica are calitatea de <strong>operator de date</strong>, cu responsabilitatea de a informa pacienții în mod complet și corect, conform GDPR.
        </p>

        <p class="mt-2">
            Operatorul are obligația de a obține consimțământul pacienților, acolo unde este necesar, și de a se asigura că datele sunt colectate și utilizate legal, transparent și în limitele scopurilor declarate.
        </p>
    </article>
    <br>

    <article id="chapter-conf-4">
        <h2 class="text-2xl font-semibold">4. Comunicarea prin email</h2>

        <h3 class="text-xl font-medium mt-4">Smiles Manager către dumneavoastră</h3>

        <p class="mt-2">
            Ca parte din serviciile noastre, puteți primi ocazional emailuri din partea noastră. Totodată, vă putem trimite emailuri care au legătură cu administrarea contului dumneavoastră.
            Informațiile furnizate în procesul de creare a contului – cum ar fi adresa de email – sunt esențiale pentru funcționarea corectă a platformei Smiles Manager. Acestea permit transmiterea unor comunicări operaționale importante, precum: recuperarea parolei, notificări privind expirarea abonamentului, alerte de securitate sau alte mesaje tehnice.
        </p>

        <p class="mt-2">
            Fără aceste comunicări, utilizarea serviciului devine parțială sau chiar imposibilă. Prin urmare, deși beneficiați de dreptul de a solicita ștergerea anumitor date personale, exercitarea acestui drept asupra informațiilor esențiale poate duce la imposibilitatea continuării utilizării platformei.
        </p>

        <p class="mt-2">
            De asemenea, pe baza adresei de email asociate contului dumneavoastră, S.C. SRP SW Solutions S.R.L. poate afișa ocazional conținut informativ și noutăți despre Smiles Manager pe platforme de social media, în măsura în care acest lucru respectă setările de confidențialitate din conturile respective.
        </p>

        <p class="mt-2">
            În toate cazurile, beneficiați de drepturile prevăzute de GDPR în ceea ce privește datele pe care ni le furnizați, după cum sunt detaliate mai jos:
        </p>

        <ul class="list-disc list-inside ml-4 mt-2 space-y-2">
            <li><strong>Dreptul de acces</strong> – aveți dreptul de a solicita informații despre modul în care sunt prelucrate datele dumneavoastră și ce date deținem despre dvs.</li>
            <li><strong>Dreptul la rectificare</strong> – puteți solicita corectarea sau completarea datelor personale inexacte sau incomplete.</li>
            <li><strong>Dreptul la ștergerea datelor („dreptul de a fi uitat”)</strong> – puteți cere ștergerea datelor atunci când nu mai sunt necesare sau dacă prelucrarea a fost ilegală.</li>
            <li><strong>Dreptul la restricționare</strong> – puteți solicita limitarea prelucrării în anumite situații (ex: contestați exactitatea datelor).</li>
            <li><strong>Dreptul la opoziție</strong> – vă puteți opune prelucrării, mai ales când aceasta se bazează pe interesul legitim al SRP SW Solutions S.R.L.</li>
            <li><strong>Dreptul la portabilitatea datelor</strong> – aveți dreptul de a primi datele într-un format structurat, ușor de citit, și de a solicita transferul către alt operator.</li>
            <li><strong>Dreptul de retragere a consimțământului</strong> – îl puteți retrage oricând, cu efect doar pentru viitor.</li>
            <li><strong>Dreptul de a depune o plângere</strong> – la ANSPDCP, dacă considerați că drepturile v-au fost încălcate (<a href="https://www.dataprotection.ro" class="text-blue-600 underline">www.dataprotection.ro</a>).</li>
        </ul>

        <h3 class="text-xl font-medium mt-6">Transmiterea de emailuri și SMS-uri către pacienți</h3>

        <p class="mt-2">
            În platforma Smiles Manager, aveți posibilitatea de a trimite emailuri și SMS-uri către pacienți, conținând documente generate (ex: programări, fișe de tratament, notificări, informații relevante).
        </p>

        <p class="mt-2">
            Dacă optați pentru transmiterea acestor mesaje prin serverele Smiles Manager, vă exprimați acordul ca S.C. SRP SW Solutions S.R.L. să acționeze în calitate de împuternicit, trimițând mesajele în numele dumneavoastră către destinatarii desemnați.
        </p>

        <p class="mt-2">
            Aceste comunicări sunt realizate exclusiv la inițiativa dumneavoastră, în baza setărilor efectuate în contul de utilizator. Furnizorul nu modifică, nu analizează și nu utilizează conținutul mesajelor în alte scopuri decât cel al transmiterii lor către pacienți.
        </p>
    </article>
    <br>

    <article id="chapter-conf-5">
        <h2 class="text-2xl font-semibold">5. Informații financiare</h2>

        <p class="mt-2">
            Toate informațiile stocate în contul dumneavoastră Smiles Manager sunt tratate cu maximă confidențialitate. La nivel intern, datele introduse de utilizatori sunt protejate prin clauze stricte de confidențialitate asumate contractual de către echipa S.C. SRP SW Solutions S.R.L.
        </p>

        <p class="mt-2">
            Nu vom transmite aceste informații către terți, cu excepția situațiilor în care dumneavoastră alegeți să conectați contul Smiles Manager cu servicii externe partenere (ex: software de contabilitate, procesatori de plăți etc.). În aceste cazuri, schimbul de date are loc exclusiv în baza integrărilor autorizate de dumneavoastră, conform celor detaliate în secțiunile corespunzătoare ale acestei politici.
        </p>
    </article>

</ng-template>


<ng-template #delivery>
    <h1 class="text-3xl font-bold mb-6">Politica de livrare comanda</h1>

    <!-- Descriere introductivă -->
    <div class="mb-8 space-y-4 text-base">
        <p>
            Această politică de livrare comanda se aplică serviciilor oferite prin intermediul aplicației Smiles Manager, dezvoltată și deținută de S.C. SRP SW Solutions S.R.L.
        </p>
        <p>
            Scopul acestei politici este să vă informăm în legătură cu metodele de livrare a serviciilor oferite prin platforma Smiles Manager.
        </p>
    </div>

    <article id="chapter-conf-1">
        <h2 class="text-2xl font-semibold">1. Abonamentul Smiles Manager</h2>

        <p class="mt-2">
            Abonamentul Smiles Manager este flexibil, si include <strong>doar acele module pe care dvs decideti ca doriti sa le activati.</strong> Module disponibile:
        </p>

        <ul class="list-disc list-inside ml-4 mt-2 space-y-2">
            <li><strong>Baza</strong> </li>
            <li><strong>Calendar și programări</strong></li>
            <li><strong>Documentare clinică stomatologie</strong></li>
            <li><strong>Digitalizare documente și chestionare</strong></li>
            <li><strong>Radiografie Afacere</strong></li>
            <li><strong>Trasabilitatea sterilizării</strong></li>
        </ul>
    </article>

    <p class="mt-2 mb-2">
        Abonamentul poate fi achitat lunar sau anual. Costul abonamentului este dat de costul fiecarui modul activat, plus numarul de unitati dentare.
        Pretul modulelor, cat si a unit-urilor dentare este exprimat in RON/luna.
    </p>

    <br>

    <article id="chapter-conf-2">
        <h2 class="text-2xl font-semibold">2. Activare/dezactivare modul din/în abonament</h2>
        <p>Activarea și dezactivarea modulelor poate fi făcută oricând.</p>
        <br>
        <h3 class="text-xl font-semibold">2.1 Activare modul nou</h3>
        <p class="mt-2">
            La activarea unui nou modul (care nu este deja
            în abonament și nu a fost plătit), în situația în care aveți deja un abonament activ,
            se va calcula diferența de timp (în luni) dintre data de activare a modulului și data de expirare a
            abonamentului.
            Costul activării va fi dat de diferența de luni × prețul lunar al modulului. Exemplu:
            Am abonament activ încă 3 luni, și vreau să mai activez modulul "Trasabilitatea sterilizării". Costul activarii va fi
            de 3 × prețul lunar al modulului "Trasabilitatea sterilizării".
            Activarea și accesul la modul se face <strong>automat</strong> după efectuarea plății.
            <br><br>
            <strong>IMPORTANT:</strong> După efectuarea plății, toți utilizatorii clinicii trebuie să facă log out apoi
            log in, pentru a avea acces la noul modul achiziționat în abonament.
        </p>

        <br>
        <h3 class="text-xl font-semibold">2.2 Dezactivare modul</h3>
        <p class="mt-2">
            Dezactivarea modulelor poate fi făcută oricând. Modulul este marcat ca și dezactivat imediat, însă accesul
            la modul nu se pierde până la expirarea abonamentului curent.
            Un modul dezactivat nu va mai fi inclus automat în prelungirea abonamentului.
        </p>

        <br>
        <h3 class="text-xl font-semibold">2.3 Reactivare modul deja plătit</h3>
        <p class="mt-2">
            Activarea unui modul, care a fost deja plătit în cadrul abonamentului curent, se face instant.
            Modulul va fi marcat ca și parte din abonament, și se va prelungi automat odată cu abonamentul.
        </p>

    </article>

    <br>
    <article id="chapter-conf-2">
        <h2 class="text-2xl font-semibold">3. Activare abonament</h2>

        <p class="mt-2">
            Activarea abonamentului se face în situația în care perioada de demo a expirat, și accesul la module a fost
            restricționat. Prin apăsarea butonului activare abonament,
            se va adăuga la plată toate modulele care fac parte din abonament. Perioada de activare a abonamentului
            poate fi configurată 1/12 luni înainte de plată.
            <br><br>
            <strong>IMPORTANT:</strong> După efectuarea plății, toți utilizatorii clinicii trebuie să facă log out apoi
            log in, pentru a avea acces la noul modul achiziționat în abonament.
        </p>
    </article>
    <br>

    <article id="chapter-conf-2">
        <h2 class="text-2xl font-semibold">4. Prelungire abonament</h2>

        <p class="mt-2">
            Prelungirea abonamentului se poate face în orice moment prin apăsarea butonului prelungire abonament.
            Se va adăuga la plată toate modulele care fac parte din abonament. Perioada de prelungire a abonamentului
            poate fi configurată 1/12 luni înainte de plată.
            <br><br>
            <strong>IMPORTANT:</strong> După efectuarea plății, toți utilizatorii clinicii trebuie să facă log out apoi
            log in, pentru a avea acces la noul modul achiziționat în abonament.
        </p>
    </article>
    <br>

    <article id="chapter-conf-2">
        <h2 class="text-2xl font-semibold">5. Achiziție resurse</h2>

        <p class="mt-2">
            În Smiles Manager, resursele sunt considerate consumabile și pot fi achiziționate individual, după cum urmează:
        <ul class="list-disc list-inside ml-4 mt-2 space-y-2">
            <li><strong>Mesaje SMS</strong></li>
            <li><strong>Mesaje e-mail</strong></li>
            <li><strong>Spațiu de stocare pentru fișiere</strong></li>
            <li><strong>Token-uri AI</strong></li>
        </ul>

        <p class="mt-4">
            Procesul de achiziție este simplu: selectați resursele dorite, adăugați-le în coșul de cumpărături și specificați cantitatea necesară.
            Costul total se calculează automat în funcție de volumul selectat. Exemplu: 100 SMS × cost per SMS.
        </p>

        <p class="mt-4">
            <strong>IMPORTANT:</strong> După confirmarea plății, resursele sunt <strong>alocate automat</strong> și pot fi utilizate <strong>imediat</strong>.
        </p>
    </article>
    <br>

    <article id="chapter-conf-3">
        <h2 class="text-2xl font-semibold">Activare eșuată?</h2>
        <p class="mt-4">
        În mod obișnuit, activarea modulelor sau a abonamentului, precum și alocarea automată a resurselor, se realizează în câteva minute de la confirmarea plății.
            În cazul în care activarea sau alocarea automată a resurselor nu s-a efectuat cu succes, vă rugăm să ne contactați utilizând informațiile disponibile pe pagina de contact.
        </p>
    </article>
</ng-template>

<ng-template #cancelOrder>
    <h1 class="text-3xl font-bold mb-6">Politica de anulare a comenzii</h1>

    <!-- Descriere introductivă -->
    <div class="mb-8 space-y-4 text-base">
        <p>
            Prezenta politică de anulare se aplică serviciilor furnizate prin intermediul aplicației Smiles Manager, dezvoltată și deținută de S.C. SRP SW Solutions S.R.L.
        </p>
        <p>
            Scopul acestei politici este de a vă informa cu privire la modalitățile de anulare a serviciilor disponibile în platforma Smiles Manager.
        </p>
    </div>

    <article id="chapter-conf-1">
        <h2 class="text-2xl font-semibold">1. Dezactivarea modulului</h2>

        <p class="mt-2">
            Modulele pot fi dezactivate în orice moment. După dezactivare, modulul este marcat ca inactiv, însă accesul rămâne disponibil până la expirarea abonamentului curent.
            Modulele dezactivate nu vor fi incluse automat în prelungirea abonamentului.
        </p>
    </article>

    <br>

    <article id="chapter-conf-1">
        <h2 class="text-2xl font-semibold">2. Dezactivarea abonamentului</h2>

        <p class="mt-2">
            Dezactivarea abonamentului se realizează automat prin decizia de a nu-l prelungi. După data de expirare, accesul la modulele incluse va fi restricționat automat.
        </p>
    </article>

    <br><br>

    <article id="chapter-conf-1">
        <h2 class="text-2xl font-semibold">Important</h2>
        <p class="mt-2">
            Nu se efectuează rambursări în următoarele situații:
        </p>
        <ul class="list-disc list-inside ml-4 mt-2 space-y-2">
            <li><strong>pentru renunțare la abonament înainte de expirare</strong></li>
            <li><strong>pentru resurse achitate și neutilizate</strong></li>
        </ul>
    </article>
</ng-template>



<div class="w-full m-8">
    <div class="flex flex-col p-12 mx-auto items-start bg-card shadow rounded-2xl max-w-256 text-justify">

        <ng-container [ngSwitch]="agreementType">
            <ng-container *ngSwitchCase="'terms-and-conditions'" [ngTemplateOutlet]="terms"></ng-container>
            <ng-container *ngSwitchCase="'confidentiality-policy'" [ngTemplateOutlet]="confidentiality"></ng-container>
            <ng-container *ngSwitchCase="'delivery-policy'" [ngTemplateOutlet]="delivery"></ng-container>
            <ng-container *ngSwitchCase="'delivery-cancel-policy'" [ngTemplateOutlet]="cancelOrder"></ng-container>
            <ng-container *ngSwitchDefault [ngTemplateOutlet]="terms"></ng-container>
        </ng-container>

    </div>

    <div class="flex flex-row w-full place-content-center mt-4">
        <button mat-flat-button color="primary" class="rounded-lg my-auto"  [routerLink]="'../'">
            <mat-icon svgIcon="mat_outline:check"></mat-icon>
            Sunt de acord
        </button>
    </div>
</div>
